import { FC } from 'react';
import { cn } from '@new/lib';

interface LabeledTextareaProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  rows?: number;
  disabled?: boolean;
  hasError?: boolean;
  placeholder?: string;
  className?: string;
}

/**
 * A labeled textarea sharing the "transcript" field look (light background +
 * subtle border) with `LabeledNumberInput`. Height is driven by `rows`, not a
 * fixed pixel height.
 */
export const LabeledTextarea: FC<LabeledTextareaProps> = ({
  label,
  value,
  onChange,
  rows = 3,
  disabled = false,
  hasError = false,
  placeholder,
  className,
}) => (
  <div className={cn('flex flex-col gap-2', className)}>
    <label className="[font-size:var(--fs-p4)]! font-medium text-(--neutral-black-NB1000)!">
      {label}
    </label>
    <textarea
      rows={rows}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      className={cn(
        'w-full rounded-[8px]! border-[1.5px]! border-solid! p-4',
        '[font-family:var(--font-montserrat)]! [font-size:var(--fs-l4)]! text-(--neutral-black-NB1000)!',
        'bg-[#FCFDFD]! placeholder:text-(--neutral-white-NW600)!',
        'focus:outline-none! focus:border-(--neutral-black-NB1000)/80!',
        'disabled:cursor-not-allowed disabled:opacity-70',
        hasError ? 'border-(--danger-D700)/80!' : 'border-[#E1E7EA]!'
      )}
    />
  </div>
);
